import { makeFeatureFlag } from '../makeFeatureFlag';

export const useHighlightClassChanges = makeFeatureFlag<boolean>(
  'Feature.HighlightClassChanges',
  false,
);
